import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { myDriveApi } from '../../constants/my-drive-api';
import { Observable } from 'rxjs';
import { PaginationType } from '../../interfaces/pagination/pagination-type';

@Injectable({
  providedIn: 'root'
})
export class MyDriveService {

  constructor(
    private httpClientService: HttpClientService,
    private _permissionPipe: PermissionsPipe // dont remove this
  ) { }

  getFolderFile(pagination: PaginationType, payload: any): Observable<any> {
    let query = '?';

    if (payload) {
      query += `${payload}`;
    }

    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${myDriveApi.getFolderFile}${query}`);
  }

  createFolder(payload: any): Observable<any> {
    return this.httpClientService.post(myDriveApi.createFolder, payload)
  }

  updateFolder(id: string, payload: any): Observable<any> {
    return this.httpClientService.put(`${myDriveApi.updateFolder}${id}`, payload)
  }

  removeFolder(id: string): Observable<any> {
    return this.httpClientService.delete(`${myDriveApi.removeFolder}${id}`)
  }

  uploadFile(payload: any): Observable<any> {
    return this.httpClientService.uploadWithProgress(myDriveApi.uploadFile, payload);
  }

  removeFile(id: string): Observable<any> {
    return this.httpClientService.delete(`${myDriveApi.removeFile}${id}`)
  }

  fileDetails(id: string): Observable<any> {
    return this.httpClientService.get(`${myDriveApi.fileDetails}${id}`);
  }

  updateFile(payload: any): Observable<any> {
    return this.httpClientService.put(`${myDriveApi.updateFile}${payload}`, {})
  }

  storeBreadcrumb(data: any) {
    localStorage.setItem('folder-breadcrumb', JSON.stringify(data));
  }

  getFolderBreadcrumb() {
   let data = JSON.parse(localStorage.getItem('folder-breadcrumb')) || '';
   return data;
  }
}
